import React from 'react';
import { useMsal } from '@azure/msal-react';
import { appInsights } from '../../services/analytics/appInsights';

const SignInButton = () => {
  const { instance, inProgress } = useMsal();

  const handleLogin = async () => {
    // Track login attempt
    if (appInsights && process.env.NODE_ENV === 'production') {
      appInsights.trackEvent({
        name: 'LoginAttemptStarted',
        properties: {
          loginMethod: 'popup',
          timestamp: new Date().toISOString()
        }
      });
    }

    try {
      const result = await instance.loginPopup();
      
      // Track successful login
      if (appInsights && process.env.NODE_ENV === 'production') {
        appInsights.trackEvent({
          name: 'LoginSuccess',
          properties: {
            loginMethod: 'popup',
            userId: result.account?.homeAccountId || 'unknown',
            userName: result.account?.name || 'unknown',           // Add this
            userEmail: result.account?.username || 'unknown',      // Add this
            tenantId: result.account?.tenantId || 'unknown',
            timestamp: new Date().toISOString()
          }
        });

        // Set user context for all future telemetry
        appInsights.setAuthenticatedUserContext(
          result.account?.localAccountId || result.account?.homeAccountId,
          result.account?.tenantId,
          result.account?.name
        );
      }

    } catch (error) {
      console.error(error);
      
      // Track login failure
      if (appInsights && process.env.NODE_ENV === 'production') {
        appInsights.trackException({
          exception: error,
          properties: {
            context: 'LoginPopup',
            errorCode: error.errorCode || 'unknown',
            errorMessage: error.errorMessage || error.message || 'unknown',
            loginMethod: 'popup',
            timestamp: new Date().toISOString()
          }
        });

        appInsights.trackEvent({
          name: 'LoginFailed',
          properties: {
            loginMethod: 'popup',
            errorCode: error.errorCode || 'unknown',
            errorType: error.name || 'unknown',
            timestamp: new Date().toISOString()
          }
        });
      }
    }
  };

  return (
    <button 
      onClick={handleLogin} 
      disabled={inProgress !== 'none'}
      className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {inProgress === 'login' ? 'Signing in...' : 'Click to Login'}
    </button>
  );
};

export default SignInButton; 